import { useGetAuthorizationData } from '@/modules/Users/queries/AuthorizerQueries'
import {
  Box,
  Flex,
  getTheme,
  Grid,
  Space,
  Tag,
  Text,
} from '@conexasaude/conexa-hero'
import { fields, statusMapping } from './AuthorizationData.constants'
import { AuthorizationDataProps } from './AuthorizationData.types'
import { RenderIf } from '@conexasaude/professional-data'

export const AuthorizationData = ({ idAuthorizer }: AuthorizationDataProps) => {
  const { authorizationData } = useGetAuthorizationData(idAuthorizer)
  const theme = getTheme()

  if (authorizationData?.isWithoutGuide || !authorizationData) {
    return null
  }

  return (
    <>
      <RenderIf condition={!authorizationData?.guideNotFound}>
        <Flex direction="column" mt={theme.spacing.md}>
          <Text variant="headingSmall">Dados de autorização</Text>
          <Space mb="xs" />
          <Box>
            <Grid gutter={theme.spacing.xs}>
              <Grid.Col span={3}>
                <Flex direction="column" gap={theme.spacing.xxs}>
                  <Text>Status</Text>
                  <Tag
                    variant={
                      statusMapping[authorizationData?.status]?.tagVariant
                    }
                  >
                    {statusMapping[authorizationData?.status]?.label}
                  </Tag>
                </Flex>
              </Grid.Col>
              {fields.map(({ label, value }) => (
                <Grid.Col key={label} span={3}>
                  <Flex direction="column" gap={theme.spacing.xxs}>
                    <Text variant="paragraphLarge">{label}</Text>
                    <Text variant="paragraphSmall">
                      {value(authorizationData, idAuthorizer)}
                    </Text>
                  </Flex>
                </Grid.Col>
              ))}
            </Grid>
          </Box>
        </Flex>
      </RenderIf>
      <RenderIf condition={authorizationData?.guideNotFound}>
        <Flex direction="column" mt={theme.spacing.md}>
          <Text variant="headingSmall">Dados de autorização</Text>
          <Space mb="xs" />
          <Box>
            <Flex justify="center" gap={theme.spacing.xxs}>
              <Text variant="paragraphLarge" color={theme.colors.neutral[200]}>
                Não foram localizados dados de autorização para este atendimento
              </Text>
            </Flex>
          </Box>
        </Flex>
      </RenderIf>
    </>
  )
}
